export const ERP_AUDIT_PERMISSIONS = {
  read: 'integration.read'
} as const;
